/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EraseIcon = ({ width = 24, height = 24, hidden = false, title = 'Erase' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.613 28.132a1 1 0 0 0 1.414 0l13.562-13.561a1 1 0 0 0 0-1.414L22.275 1.843a1 1 0 0 0-1.414 0L7.3 15.4a1 1 0 0 0 0 1.414l.707.707-6.3 6.3a2 2 0 0 0 0 2.829l6.505 6.5a2.8 2.8 0 0 0 1.921.85H33.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H13.331l4.575-4.575ZM10.9 31.607a1 1 0 0 1-1.414 0l-6.368-6.364 6.3-6.3 7.071 7.071Z"
    />
  </svg>`;
};
